iScreenWizard.factory('Handleiding', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('handleiding', params).then(function (response) {
                var handleidingen = response.data;
                resolve(handleidingen);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('handleiding/'+id).then(function (response) {
                var handleiding = response.data;
                resolve(handleiding);
            }, reject);
        });
    };

    return data;
});